module.exports = __webpack_public_path__ + "static/media/EE-logo-2025-white.f5378bf0.png";